var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-footer bg-color"},_vm._l((_vm.menus),function(item,index){return _c('div',{class:[_vm.active==index?'z-footer-active':'normal']},[_c('router-link',{attrs:{"to":item.href}},[_c('img',{attrs:{"src":_vm.active==index?item.iconActive:item.icon}}),_vm._v(" "),_c('label',{domProps:{"textContent":_vm._s(item.label)}})])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5292c74f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ButtomMenu.vue
// module id = null
// module chunks = 